// import Vue from 'vue/dist/vue.esm.js';
import Vue from 'vue'

export default Vue.directive('hashanimate', {

  bind: function (el, binding, vnode) {
    el.addEventListener('click',

    function(e) {
        e.preventDefault();

        // store hash
        var hash  = this.hash;
        var ms    = binding.value.timing;

        if (hash){

            console.log('hash',hash);
            var hashId = hash.replace('#','');
            var element = document.getElementById(hashId);

            element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            window.location.hash = hash;

            // animate
            // $('html, body').animate({
            //     scrollTop: $(this.hash).offset().top
            // }, ms, function(){
            //
            // });
        }
    });

  }

});
